var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 col-md-8" },
          [
            _c("ob1-liens", {
              staticClass: "p-0 text-left",
              attrs: {
                "is-button": "",
                "modal-id": _vm.modalId,
                "data-toggle": "modal",
                text: _vm.odrName,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-md-4 font-weight-bold amount" }, [
          _c("span", [_vm._v(_vm._s(_vm.odrAmount))]),
        ]),
      ]),
      _vm._v(" "),
      _c("promo-odr-popin", {
        attrs: {
          "odr-amount-in-cents": _vm.odrAmountInCents,
          "odr-start-date": _vm.odrStartDate,
          "odr-end-date": _vm.odrEndDate,
          "odr-link": _vm.odrLink,
          "modal-id": _vm.modalId,
          "promo-odr-messages": _vm.promoOdrMessages,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }